import React, { useState, useRef } from "react";
import { Controller } from "react-hook-form";
import { get } from "react-hook-form";
import DeleteButton from "./DeleteButton";
import { truncateString } from "~/components/utils/StringFormatter";

const FileUpload = ({
  name,
  label,
  required = false,
  multiple = false,
  field: { value, onChange },
  errors = {},
  accept = "",
  buttonClasses = "button",
  onFileSelect = () => {},
}) => {
  const errorForName = get(errors, name);
  const inputRef = useRef();
  const files = value;

  const handleFiles = (e) => {
    onFileSelect();

    if (multiple) {
      onChange(files.concat(Array.from(e.target.files)));
      e.target.value = "";
    } else {
      onChange(Array.from(e.target.files));
    }
  };

  const deleteFile = (file) => {
    onChange(files.filter((f) => f != file));

    if (!multiple) {
      inputRef.current.value = "";
    }
  };

  const renderFile = (file) => {
    return (
      <div key={file.name} className="file_upload__file">
        <div className="file_upload__icon">
          <DeleteButton onClick={() => deleteFile(file)} />
        </div>
        <div className="file_upload__details">
          <div className="file_upload__details__title">{truncateString(file?.name, 30)}</div>
          <div className="file_upload__details__subtitle">{file?.type}</div>
        </div>
      </div>
    );
  };

  const renderFiles = () => {
    if (files.length > 0) {
      return <div>{files.map((file) => renderFile(file))}</div>;
    }

    if (multiple) {
      return (
        <div>
          <div className="t--black t--sm">Please ensure any PHI or pricing data for other</div>
          <div className="t--black t--sm">manufacturers is fully redacted from the attachment.</div>
        </div>
      );
    } else {
      return (
        <div className="file_upload__note">
          Please select a file to upload {required ? "- this field is required" : ""}
        </div>
      );
    }
  };

  return (
    <div className="form__group">
      <label className="form__label">{label}</label>
      <div className="file_upload">
        <span className="material-symbols-rounded t--xxl">warning</span>
        {renderFiles()}
        <div className="file_upload__button">
          <button type="button" className={buttonClasses} onClick={() => inputRef.current.click()}>
            <span className="material-symbols-outlined">post_add</span>
            {multiple ? "Select Files" : "Select File"}
          </button>
        </div>
        <input
          type="file"
          name={name}
          id={name}
          ref={inputRef}
          multiple={multiple}
          style={{ display: "none" }}
          onChange={handleFiles}
          aria-invalid={errorForName}
          accept={accept}
        />
      </div>
      {errors && errorForName && <div className="form__error--message">{errorForName["message"]}</div>}
    </div>
  );
};

const FileUploadController = (props) => {
  const {
    name,
    label,
    ref,
    required = false,
    multiple = false,
    control,
    errors = {},
    accept = "",
    buttonClasses = "button",
  } = props;

  return (
    <Controller
      control={control}
      name={name}
      rules={required ? { required: "This field is required." } : undefined}
      defaultValue={[]}
      render={({ field }) => FileUpload({ ...props, field })}
    />
  );
};

export default FileUploadController;
